<template>
	<v-form ref="attributeForm">
		<v-card-text>
			<v-layout wrap>
				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 sm6 md3>
							<v-switch v-model="form.is_hidden" name="is_hidden" label="Is Hidden"></v-switch>
						</v-flex>
						<v-flex xs12 sm6 md3>
							<v-switch v-model="form.in_decision_tree" name="in_decision_tree" label="Is Filterable"></v-switch>
						</v-flex>
						<v-flex xs12 sm6 md3>
							<v-switch v-model="isConfigurable" name="isConfigurable" label="Is Configurable"></v-switch>
						</v-flex>
						<v-flex xs12 sm6 md3>
							<v-text-field
								label="Display Order"
								outline
								v-model="form.order"
								name="order"
								:hide-details="!errors.has('order')"
								:error="errors.has('order')"
								:error-count="errors.count('order')"
								:error-messages="errors.get('order')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>

				<v-flex xs12>
					<v-layout wrap>
						<v-flex xs12 md6>
							<v-text-field
								label="Attribute Name"
								outline
								v-model="form.name"
								name="name"
								:hide-details="!errors.has('name')"
								:error="errors.has('name')"
								:error-count="errors.count('name')"
								:error-messages="errors.get('name')"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md6>
							<v-text-field
								label="Units (Plural)"
								outline
								v-model="form.units"
								name="units"
								:hide-details="!errors.has('units')"
								:error="errors.has('units')"
								:error-count="errors.count('units')"
								:error-messages="errors.get('units')"
							></v-text-field>
						</v-flex>
					</v-layout>
				</v-flex>

				<v-flex xs12 v-if="isConfigurable">
					<v-layout wrap>
						<v-flex xs12 md6>
							<v-text-field
								label="Field Label"
								outline
								v-model="form.label"
								name="label"
								:hide-details="!errors.has('label')"
								:error="errors.has('label')"
								:error-count="errors.count('label')"
								:error-messages="errors.get('label')"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md6>
							<v-autocomplete
								label="Field Type"
								outline
								:items="fieldTypes"
								v-model="form.type"
								name="type"
								clearable
								:hide-details="!errors.has('type')"
								:error="errors.has('type')"
								:error-count="errors.count('type')"
								:error-messages="errors.get('type')"
							></v-autocomplete>
						</v-flex>
					</v-layout>
				</v-flex>

				<v-flex xs12 v-if="isConfigurable">
					<v-layout wrap>
						<v-flex xs12 md6 v-if="form.type === 'int' || form.type === 'string'">
							<v-text-field
								label="Minimum Value"
								outline
								type="number"
								v-model="form.min"
								name="min_value"
								:hide-details="!errors.has('min')"
								:error="errors.has('min')"
								:error-count="errors.count('min')"
								:error-messages="errors.get('min')"
							></v-text-field>
						</v-flex>
						<v-flex xs12 md6 v-if="form.type === 'int' || form.type === 'string'">
							<v-text-field
								label="Maximum Value"
								outline
								type="number"
								v-model="form.max"
								name="max_value"
								:hide-details="!errors.has('max')"
								:error="errors.has('max')"
								:error-count="errors.count('max')"
								:error-messages="errors.get('max')"
							></v-text-field>
						</v-flex>

						<v-flex xs12 v-if="form.type === 'select'">
							<v-combobox
								v-model="form.values"
								multiple
								small-chips
								deletable-chips
								hide-no-data
								outline
								:append-icon="''"
								name="select_values"
								label="Enter Options"
								item-text="name"
								:hide-details="!errors.has('values')"
								:error="errors.has('values')"
								:error-count="errors.count('values')"
								:error-messages="errors.get('values')"
							></v-combobox>
						</v-flex>
					</v-layout>
				</v-flex>

				<v-flex xs12 v-if="isConfigurable">
					<v-text-field
						label="Tooltip"
						outline
						v-model="form.tooltip"
						name="tooltip"
						:hide-details="!errors.has('tooltip')"
						:error="errors.has('tooltip')"
						:error-count="errors.count('tooltip')"
						:error-messages="errors.get('tooltip')"
					></v-text-field>
				</v-flex>

				<v-flex xs12 v-if="isConfigurable">
					<v-layout wrap>
						<v-flex xs12 sm6 md4 v-if="form.type == 'int'">
							<v-switch v-model="form.is_discountable" name="is_discountable" label="Is Discountable"></v-switch>
						</v-flex>
						<v-flex xs12 sm6 md4 v-if="form.type != 'string'">
							<v-switch v-model="form.is_addition" name="is_addition" label="Is Addition"></v-switch>
						</v-flex>
						<v-flex xs12 sm6 md4 v-if="form.type !== 'string' && form.type !== 'int'">
							<v-autocomplete
								label="Based On"
								v-model="form.based_on"
								name="based_on"
								outline
								:items="basedOnAtts"
								item-text="name"
								item-value="slug"
								clearable
								browser-autocomplete="disabled"
								:hide-details="!errors.has('based_on')"
								:error="errors.has('based_on')"
								:error-count="errors.count('based_on')"
								:error-messages="errors.get('based_on')"
								v-if="basedOnAtts"
							></v-autocomplete>
						</v-flex>
					</v-layout>
				</v-flex>
			</v-layout>
		</v-card-text>

		<v-card-actions class="pa-3">
			<v-btn color="error" @click="deleteAttribute" v-if="attribute">Delete</v-btn>
			<v-spacer></v-spacer>
			<v-btn @click="secondaryAction">{{secondaryActionText}}</v-btn>
			<v-btn color="primary" @click="submit">{{submitText}}</v-btn>
		</v-card-actions>
		<!-- <code>{{ATTRIBUTES}}</code> -->
	</v-form>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Errors from "@root/helpers/Errors";

export default {
	data() {
		return {
			fieldTypes: [
				{
					text: "String",
					value: "string"
				},
				{
					text: "Number",
					value: "int"
				},
				{
					text: "True/False",
					value: "bool"
				},
				{
					text: "Dropdown",
					value: "select"
				}
			],
			isConfigurable: false,
			form: {
				name: "",
				label: "",
				is_hidden: true,
				order: 0,
				in_decision_tree: false,
				type: null,
				values: [], // type - select
				units: "", // type =  int || string
				min: 0, // type =  int || string
				max: 9999, // type =  int || string
				tooltip: "",
				is_discountable: false, // type == int
				based_on: "", // type != int || string
				is_addition: false // type != string
			},
			errors: new Errors()
		};
	},

	computed: {
		...mapGetters("admin", {
			ATTRIBUTES: "attributes"
		}),

		secondaryActionText() {
			return this.attribute ? "Cancel" : "Reset";
		},

		submitText() {
			return this.attribute ? "Save Changes" : "Create Attribute";
		},

		basedOnAtts() {
			if (this.ATTRIBUTES) {
				return _.filter(this.ATTRIBUTES, { type: "int" });
			}

			return false;
		}
	},

	methods: {
		...mapActions("admin", {
			// CREATE_ATTRIBUTE: "createAttribute",
			UPDATE_ATTRIBUTE: "updateAttribute",
			DELETE_ATTRIBUTE: 'deleteAttribute'
		}),

		secondaryAction(id) {
			if (this.attribute) {
				this.$router.back();
				return;
			}

			this.$refs.attributeForm.reset();
			this.errors.clear();

			if (id) {
				this.$router.push(`/admin/attributes/${id}`);
			}
		},

		submit() {
			this[this.attribute ? "updateAttribute" : "createAttribute"]
				.call(this)
				.then(data => {
					this.secondaryAction(!this.attribute ? data.id : false);

					return data;
				})
				.catch(error => {
					error = Object.assign({}, error);
					this.errors.record(error.response.data.errors);
				});
		},

		// createAttribute() {
		// 	return this.CREATE_ATTRIBUTE(this.form);
		// },

		updateAttribute() {
			if (!this.isConfigurable) {
				this.$set(this.form, "type", null);
			}

			return this.UPDATE_ATTRIBUTE({
				form: this.form,
				id: this.attribute.id
			});
		},

		deleteAttribute() {
			this.DELETE_ATTRIBUTE(this.attribute.id).then((data) => {
				if(data.success) {
					this.$router.replace('/admin/attributes/');
				}
			});
		}
	},

	props: {
		attribute: {
			default: false
		}
	},

	created() {
		if (this.attribute) {
			_.forIn(this.form, (value, key) => {
				value = this.attribute[key];

				if (key === "type" && value) {
					this.isConfigurable = true;
				}

				this.$set(this.form, key, value);
			});
		}
	}
};
</script>
